import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import { api } from './services/api';
import { useAutoLogout } from './hooks/useAutoLogout';

function App() {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  // בדוק אם יש token שמור
  useEffect(() => {
    const userInfo = api.getUserInfo();
    if (userInfo) {
      setUser({
        username: userInfo.name,
        userCode: userInfo.userCode,
        type: userInfo.type,
        contracts: userInfo.contracts,
        dashboard: userInfo.dashboard,
      });
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    api.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  // ניתוק אוטומטי אחרי 2 שעות של חוסר פעילות
  useAutoLogout(handleLogout, isAuthenticated);

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <Dashboard user={user} onLogout={handleLogout} />
      )}
      
      {/* קישור למדיניות פרטיות */}
      <a 
        href="#" 
        className="privacy-policy-link"
        onClick={(e) => {
          e.preventDefault();
          setShowPrivacyPolicy(true);
        }}
      >
        מדיניות פרטיות
      </a>
      
      {/* מודל מדיניות פרטיות */}
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
    </div>
  );
}

export default App;
